export { useMorphemeInfoPanelDictionaryOverviewWordSection } from "#morpheme-info-panel-dictionary-overview-word-view";
